import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// components
import Modal from 'shared/modals/Modal';
import { FormikInput, FormikSelect } from 'shared/forms';
import LoadingModal from 'shared/loading/LoadingModal';
// helpers
import { handleNumberChange } from 'shared/../helpers/fields';
import toastr from 'shared/helpers/toastr';
import errorToastr from 'shared/helpers/errorToastr';
// store
import { useSelector } from 'react-redux';
import { getFuelTypes } from 'src/slices/fuelTypes';
// fetch
import { upsertSafetyInfo } from 'src/fetch/drivers';

const fuelInfoSchema = Yup.object().shape({
  comdataNumber: Yup.number().nullable(),
  fuelType: Yup.number().nullable(),
  safetyRepId: Yup.number().nullable(),
});

const FuelInfoModal = ({
  initialValues,
  onClose,
  // formik
  values,
  setFieldTouched,
  setFieldValue,
  handleChange,
  handleSubmit,
  isSubmitting,
  resetForm,
  touched,
  errors,
}) => {
  const fuelTypes = useSelector(getFuelTypes);

  const handleReset = () => {
    onClose();
    resetForm();
  };

  return (
    <Modal
      isOpen
      title={`${initialValues?.id ? 'Edit' : 'Add'} Fuel Info`}
      handleClose={handleReset}
      containerStyle='large'
    >
      <section className={`additional-charges-form modal-body`} style={{ overflowX: 'visible' }}>
        <LoadingModal isOpen={isSubmitting} isNested={true} />
        <form onSubmit={handleSubmit}>
          <section className='formik-form rows'>
            <div className='formik-row'>
              <FormikInput
                wrapperClass='wrapper-two-column'
                type='text'
                label='Fuel Card #'
                name='comdataNumber'
                maxLength={20}
                value={values.comdataNumber}
                onChange={(e) => handleNumberChange(e, values.comdataNumber, handleChange)}
              />
              <FormikSelect
                wrapperClass='wrapper-two-column'
                label='Fuel Type'
                name='fuelType'
                isClearable
                options={fuelTypes?.map(({ description, value }) => ({ value, label: description }))}
                onChange={(selected) => setFieldValue('fuelType', selected?.value)}
                value={values.fuelType}
                onBlur={setFieldTouched}
                touched={touched}
                errors={errors}
              />
            </div>
          </section>
          <section className='toolbar toolbar--xxs'>
            <div className='toolbar--column toolbar--right'>
              <button
                type='submit'
                className='button large primary text-align--center toolbar--button--margin'
                disabled={isSubmitting || !isEmpty(errors)}
              >
                Save
              </button>
              <button
                id='add-additional-charge-cancel'
                type='button'
                className='button large white text-align--center margin--none--xxs'
                onClick={handleReset}
              >
                Cancel
              </button>
            </div>
          </section>
        </form>
      </section>
    </Modal>
  );
};

FuelInfoModal.propTypes = {
  onClose: PropTypes.func,
  initialValues: PropTypes.object,
  values: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  touched: PropTypes.object,
  errors: PropTypes.object,
  isSubmitting: PropTypes.bool,
  resetForm: PropTypes.func,
};

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues }) =>
    initialValues ? { ...initialValues } : { comdataNumber: '', fuelType: '', safetyRepId: '' },
  validationSchema: fuelInfoSchema,
  handleSubmit: async (values, { setSubmitting, resetForm, props: { driverId, onClose } }) => {
    setSubmitting(true);

    upsertSafetyInfo(driverId, values)
      .then(() => {
        onClose(true);
        resetForm();
        toastr('success', `Fuel Info Saved Successfully.`);
      })
      .catch((error) => {
        console.log('Error posting Fuel Info', error);
        errorToastr({
          error,
          messagePrefix: 'Fuel Info Update Failed',
        });
        setSubmitting(false);
      });
  },
})(FuelInfoModal);
